<template>
  <div>
    <div class="bg-light-yellow">
      <div class="menu-top__wrapper weiby-container">
        <section class="menu-top-infos__wrapper">
          <section
            :class="{ 'mt-4': !showAuthInfos }"
            class="menu-top-infos__wrapper--infos"
          >
            <router-link
              v-if="showAuthInfos"
              alt="Back to menu"
              class="mb-4 text-gray-500"
              to="/menu"
            >
              <i class="icon-chevron-left mr-2 text-sm" />
              <span class="sm:text-sm">返回</span>
            </router-link>
            <div class="sm:mb-4">
              <section class="flex flex-col gap-2 items-baseline mb-2 sm:flex-row">
                <label class="mr-1 text-gray-500 text-sm">領取時段</label>
                <periods-display :periods="allowedReceivePeriods" />
              </section>
              <section v-if="!isScheduled" class="flex items-baseline text-red-700">
                <i class="icon-timeout mr-1" />
                <span class="flex">
                  訂購截止時間：
                  <displayed-time-format
                    :period="infos.expired_periods[0]"
                    show-weekday
                    text-color-class="text-red-700"
                    text-size-class="text-base"
                    text-weight-class="font-normal"
                  />
                </span>
              </section>
            </div>
          </section>
          <section class="flex ml-6 sm:ml-0">
            <div
              :class="[
                $breakpoints.sm ? 'flex-row justify-between w-full' : 'flex-col justify-start',
                showAuthInfos && !$breakpoints.sm ? 'mt-10': 'mt-4'
              ]"
              class="flex last:mr-0 mr-12 sm:mr-0"
            >
              <div class="flex items-center mb-2 sm:mb-4">
                <div>
                  <section class="flex flex-col gap-2 sm:flex-row mb-2">
                    <label class="mr-1 text-gray-500 text-sm">訂購名稱</label>
                    <p class="font-medium sm:text-lg text-xl">{{ infos.name }}</p>
                  </section>
                  <section>
                    <i class="icon-store mr-1" />
                    <span class="text-gray-500">訂購店家：</span>
                    <a
                      v-if="infos.store_url"
                      :href="infos.store_url"
                      class="no-underline text-blue-400"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ infos.store_name }}
                    </a>
                    <span v-else class="text-gray-500">{{ infos.store_name }}</span>
                  </section>
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="infos.note"
            :class="showAuthInfos ? 'pt-10': 'pt-5'"
            class="menu-top-infos__wrapper--note"
          >
            <i class="icon-note mr-2" />
            <div class="flex flex-col sm:mt-0">
              <label class="text-gray-500 text-sm">
                訂購備註
              </label>
              <div class="mb-0 mt-2" v-html="infos.note" />
            </div>
          </section>
        </section>
        <member-orders
          v-if="!!memberOrders.length"
          class="menu-top-orders__wrapper"
          :orders="memberOrders"
          :order-name="infos.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MenuTopInfos from './MenuTopInfos';

export default MenuTopInfos;
</script>

<style lang="scss" scoped>
@import 'MenuTopInfos';
</style>
